import { render, staticRenderFns } from "./GameDataScoreBoard.vue?vue&type=template&id=01ba3952&scoped=true&"
import script from "./GameDataScoreBoard.vue?vue&type=script&lang=js&"
export * from "./GameDataScoreBoard.vue?vue&type=script&lang=js&"
import style0 from "./GameDataScoreBoard.vue?vue&type=style&index=0&id=01ba3952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ba3952",
  null
  
)

export default component.exports